<ng-template>
  @if (icon(); as icon) {
    <bit-icon [name]="icon" class="tw-me-2" />
  }
  <ng-content></ng-content>
</ng-template>
